/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import orderClient from '../checkout-apis/orderClient';

const RESOURCE_ROOT_ADDRESSSERVICE = 'addressbook';
const RESOURCE_VERSION_ADDRESS = '/v2';
const RESOURCE_PAGE_ADDRESSSERVICE = '/contacts';
const RESOURCE_PAGE_ACTION = '/entries';

const getAllAddressBook = ({
    wcEnv, contactId, pageNumber, jwtToken,
}) => {
    const params = {};

    const resourcePage = `${RESOURCE_ROOT_ADDRESSSERVICE}${RESOURCE_VERSION_ADDRESS}${RESOURCE_PAGE_ADDRESSSERVICE}/${contactId}${RESOURCE_PAGE_ACTION}`;
    return orderClient.getRequest(wcEnv, resourcePage, jwtToken, params)
        .then((response) => response);
};

export default getAllAddressBook;
